import { render, staticRenderFns } from "./LanguageComponent.vue?vue&type=template&id=ad2e0a7a&"
import script from "./LanguageComponent.vue?vue&type=script&lang=js&"
export * from "./LanguageComponent.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports